export class Rejoininfo {
  timestamp: number;
  playerId: string;
  gameId: string;
}
